// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const StatusNaIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth={2} />
    <path stroke="currentColor" strokeWidth={2} d="m7.13 16.68 9.55-9.55" />
  </svg>,
  "StatusNa",
);
export default StatusNaIcon;
